import * as React from 'react';

import { Preloader } from '@cian/preloader-component';
import { mergeStyles } from '@cian/utils';
import { EyeClosed } from './icons';
import * as styles from './index.css';

const noop = () => void 0;

export interface IHideButtonStoreProps {
  isChecked?: boolean;
  isFetching?: boolean;
}

export interface IHideButtonDispatchProps {
  hideOffer?(): void;
  restoreOffer?(): void;
}
interface IHideButtonOwnProps {
  isDisabled?: boolean;
  className?: string;
}

export type IHideButtonProps = IHideButtonStoreProps & IHideButtonDispatchProps & IHideButtonOwnProps;

export class HideButton extends React.Component<IHideButtonProps, {}> {

  public render() {
    const {
      isChecked,
      isDisabled,
      hideOffer,
      className,
      isFetching } = this.props;

    return (
      <div {...mergeStyles(styles['hide_button_outer'], className)}>
        {isFetching
          ? <div className={styles['preloader']}>
              <Preloader size={16} />
            </div>
          : <EyeClosed/>
        }
        <input
          className={styles['hide_button_checkbox']}
          type="checkbox"
          checked={isChecked}
          //нельзя скрывать несколько офферов параллельно
          onChange={isFetching ? noop : hideOffer}
          disabled={isDisabled}
          title="Скрыть объявление"
        />
      </div>
    );
  }
}
